import { render } from "./Actions.vue?vue&type=template&id=78aa3992&scoped=true"
import script from "./Actions.vue?vue&type=script&lang=js"
export * from "./Actions.vue?vue&type=script&lang=js"

import "./Actions.vue?vue&type=style&index=0&id=78aa3992&lang=scss&scoped=true"

import exportComponent from "/var/www/miniapp-sigur-admin-panel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78aa3992"],['__file',"src/assets/js/components/Actions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "78aa3992"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('78aa3992', __exports__)) {
    api.reload('78aa3992', __exports__)
  }
  
  module.hot.accept("./Actions.vue?vue&type=template&id=78aa3992&scoped=true", () => {
    api.rerender('78aa3992', render)
  })

}


export default __exports__